<!--
 * @Author: panmy
 * @LastEditTime: 2025-06-12 15:07:48
 * @Description: 织语扫码登录组件
-->
<template>
  <Dialog
    ref="zhiyuLogin"
    title="智慧鹤工扫码登录"
    width="300"
    height="400"
    @close="closeZhiyuLogin"
    style="padding: 20px"
  >
    <a-spin :spinning="spinning">
      <div class="zhiyu-scan-container">
        <div id="zhiyu_qrcode"></div>
        <div class="scan-tip">请使用智慧鹤工APP扫描二维码登录</div>
      </div>
    </a-spin>
    <template slot="butList">
      <div></div>
    </template>
  </Dialog>
</template>

<script>
import { commonAPI } from "@/apis";
import { Dialog } from "@/components/public/dialog/ant";
import { currentLanguage } from "@/utils/helpers";

export default {
  name: "ZhiyuLogin",
  components: { Dialog },
  props: {
    loginItem: {
      type: Object,
      default: () => ({}),
    },
    redirectUri: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      spinning: false,
      zhiyuLoginInstance: null,
      currentLanguage: "简体中文",
    };
  },
  created() {
    this.currentLanguage = currentLanguage(true).text;
  },
  methods: {
    // 打开织语扫码登录弹窗
    openZhiyuLogin() {
      if (this.redirectUri && this.redirectUri !== "") {
        sessionStorage.setItem("REDIRECT_URI", this.redirectUri);
      }
      this.$refs.zhiyuLogin.openModal();
      this.spinning = true;
      // 动态加载织语登录脚本
      this.loadZhiyuLoginScript()
        .then(() => {
          // 获取织语登录配置
          this.getZhiyuLoginConfig()
            .then((config) => {
              // 初始化织语登录
              this.initZhiyuLogin(config);
            })
            .catch((err) => {
              this.$message.error("获取织语登录配置失败：" + err.message);
              this.$refs.zhiyuLogin.closeModal();
            });

          // this.initZhiyuLogin({});
        })
        .catch((err) => {
          this.spinning = false;
          this.$message.error("加载织语登录脚本失败：" + err.message);
          this.$refs.zhiyuLogin.closeModal();
        });
    },

    // 关闭织语扫码登录弹窗
    closeZhiyuLogin() {
      this.$refs.zhiyuLogin.closeModal();
      // 销毁实例
      if (this.zhiyuLoginInstance) {
        this.zhiyuLoginInstance.destroyed();
        this.zhiyuLoginInstance = null;
      }
    },

    // 动态加载织语登录脚本
    loadZhiyuLoginScript() {
      return new Promise((resolve, reject) => {
        // 检查是否已经加载
        if (window.CCLogin) {
          resolve();
          return;
        }

        // 使用script标签加载外部JS文件
        const script = document.createElement("script");
        // 使用public目录下的SDK文件
        script.src = "/assets/zhiyu/ccLogin.js";
        script.async = true;
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject(new Error("加载织语登录脚本失败"));
        };
        document.head.appendChild(script);
      });
    },

    // 获取织语登录配置
    async getZhiyuLoginConfig() {
      const that = this;
      try {
        // 从后端获取配置
        const { code, data } = await commonAPI.getAction(
          `/login/get/%E7%BB%87%E8%AF%AD`,
          {
            url: "thirdLogin",
          }
        );
        if (code === 0) {
          return data;
        } else {
          throw new Error("获取织语登录配置失败");
        }
      } catch (error) {
        that.spinning = false;
        // 日志记录错误
        console.error("获取织语登录配置失败:", error);
      }
    },

    // 初始化织语登录
    initZhiyuLogin(config) {
      // 销毁之前的实例
      if (this.zhiyuLoginInstance) {
        this.zhiyuLoginInstance.destroyed();
        this.zhiyuLoginInstance = null;
      }

      // 创建新的织语登录实例
      this.$nextTick(() => {
        // 检查CCLogin是否可用
        if (typeof window.CCLogin !== "function") {
          this.$message.error("织语登录SDK未加载成功");
          return;
        }

        try {
          document.getElementById("zhiyu_qrcode").innerHTML = "";
          this.zhiyuLoginInstance = new window.CCLogin({
            id: "zhiyu_qrcode",
            appid: config.appid,
            cid: config.cid,
            redirect_uri: `${config.redirect_uri}`,
            server_ip: `http://${config.server_ip}`,
            app_name: "智慧鹤工",
            lang: "zh",
            self_redirect: false,
          });
          console.log("织语扫码登录初始化成功");

          // 添加iframe居中样式
          this.$nextTick(() => {
            const iframe = document.querySelector("#zhiyu_qrcode iframe");
            if (iframe) {
              iframe.style.display = "block";
              iframe.style.margin = "0 auto";
              iframe.style.width = "200px";
              iframe.style.height = "200px";
              iframe.onload = () => {
                this.spinning = false;
              };
            }
          });
        } catch (error) {
          this.spinning = false;
          console.error("初始化织语登录失败:", error);
          this.$message.error("初始化织语登录失败");
        }
      });
    },
  },

  beforeDestroy() {
    // 组件销毁时清理资源
    if (this.zhiyuLoginInstance) {
      this.zhiyuLoginInstance.destroyed();
      this.zhiyuLoginInstance = null;
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.ant-modal-body) {
  padding: 20px !important;
}
/* 织语扫码登录样式 */
.zhiyu-scan-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;

  #zhiyu_qrcode {
    width: 250px;
    min-height: 250px;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;

    /* 确保iframe居中显示 */
    iframe {
      display: block;
      margin: 0 auto;
    }
  }

  .scan-tip {
    font-size: 16px;
    color: #666;
    text-align: center;
  }
}
</style>
<style>
body {
  width: 100% !important;
}
</style>
